// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__h9so-","icon":"SortAdornment_icon__1Fbxt","up":"SortAdornment_up__GAM9o","down":"SortAdornment_down__1_pYu","active":"SortAdornment_active__FbxAa"};